export default __webpack_public_path__ + "f2dd25050a0b305774c206a06711eec6.png";